const URL_STRING = "https://calendar-dot-test-ui-development.et.r.appspot.com";
// const URL_STRING = "http://localhost:5000";

export default URL_STRING;
